export enum EntityType {
  STORE = 'STORE',
  PLACE = 'PLACE',
}
